<template>
  <form class="m-4 md:mx-8 md:mt-16">
    <section>
      <h1 class="px-4 md:px-8 py-2 text-2xl font-bold bg-primario text-gray-200 tracking-wide rounded-t">
        {{ $t("lang.msg.sample") }}
      </h1>
      <div class="bg-white p-4 md:p-8">
        <div class="flex items-end flex-wrap lg:flex-no-wrap lg:space-x-8">
          <PlanningImages :id-comercial-request="comercialRequest.idComercialRequest" :cloned="comercialRequest.cloned" />

          <div class="w-full lg:max-w-xl">
            <div class="flex flex-wrap md:flex-no-wrap items-end justify-between md:space-x-16">
              <div class="w-full grid grid-cols-1 gap-4 lg:max-w-lg ml-2 my-2 xl:m-0">
                <InputWrapper :label="$t('lang.msg.reference')">
                  <span>{{ concatTwoValues(comercialRequest.comercialRequestReference, comercialRequest.comercialRequestReferenceNumber) }}</span>
                </InputWrapper>
                <InputWrapper :label="$t('lang.msg.signupDate')">
                  {{ sample.sampleDateSignUp|moment }}
                </InputWrapper>
              </div>

              <PlanningDays
                class="min-w-56"
                :index="1"
                :delivery-date="sample.fechaEstimadaLlegada"
                :activation-date="sample.sampleDateSignUp"
                :end-date="sample.sampleToProductionDate"
                :is-finished="sample.sampleToProduction"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- === DATOS GENERALES DE LA SOLICITUD COMERCIAL (GENERAL DATA) === -->
    <section class="mt-8">
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t" v-on:click="collapse('general')">
        <h2>{{ $t("lang.msg.generalData") }}</h2>
          <span :class="{'toggled':collapsed.general}">▲</span>
      </div>
      <div v-if="collapsed.general" class="bg-white p-4 md:p-8 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8 xl:gap-4">
        <div class="space-y-4">
            <InputWrapper :label="$t('lang.msg.reference2')" content="input">
                <InputText v-model="comercialRequest.comercialRequestReference2" :name="$t('lang.msg.reference2')" />
            </InputWrapper>
          <InputWrapper :label="$t('lang.msg.internalReference')">
            <span>{{ concatTwoValues(comercialRequest.comercialRequestReference, comercialRequest.comercialRequestReferenceNumber) }}</span>
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.clientReference')" content="input">
            <InputText v-model="comercialRequest.comercialRequestClientReference" :name="$t('lang.msg.clientReference')" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.internalSalesman')" content="input">
            <Select
              id="idEmployee"
              :data="employees"
              track-by="employeeName"
              track-by2="employeeLastName"
              v-model.number="comercialRequest.idEmployee"
              @change="changeEmployee($event)"
            />
          </InputWrapper>
        </div>

        <div class="space-y-4">
          <InputWrapper :label="$t('lang.msg.clientGroup')" content="input">
            <InputText v-model="comercialRequest.groupName" :name="$t('lang.msg.clientGroup')" disabled />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.clientBrand')" content="input">
            <Select
              id="idClient"
              ref="idClient"
              :data="clients"
              track-by="clientName"
              :error="formHasErrors && !comercialRequest.idClient"
              v-model.number="comercialRequest.idClient"
              @change="filterPerClient($event)"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.clientDepartment')" content="input">
            <Select
              id="idSection"
              :data="sections"
              track-by="sectionName"
              v-model.number="comercialRequest.idSection"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.clientSalesman')" content="input">
            <Select
              id="idBuyer"
              :data="filteredBuyers"
              track-by="buyerName"
              track-by2="buyerLastName"
              v-model.number="comercialRequest.idBuyer"
            />
          </InputWrapper>
        </div>

        <div class="space-y-4">
          <InputWrapper :label="$t('lang.msg.clientDesigner')" content="input">
            <Select
              id="idDesigner"
              :data="filteredDesigners"
              track-by="designerName"
              track-by2="designerLastName"
              v-model.number="comercialRequest.idClientDesigner"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.article')" content="input">
            <Select
              id="idSubfamilyArticle"
              :data="subfamilyArticles"
              :track-by="getLangLabel('subfamilyArticle')"
              v-model.number="comercialRequest.idSubfamilyArticle"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.collection')" content="input">
            <Select
              id="idCollection"
              :data="collections"
              :track-by="getLangLabel('collection')"
              v-model.number="comercialRequest.idCollection"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.season')" content="input">
            <Select
              id="idSeason"
              :data="seasons"
              :track-by="getLangLabel('season')"
              v-model.number="comercialRequest.idSeason"
            />
          </InputWrapper>
        </div>
      </div>
    </section>
      <br>
    <!-- === DATOS GENERALES DE LA SOLICITUD COMERCIAL (GENERAL DATA) === -->

    <!-- ========================================== -->
    <!-- === DATOS TÉCNICOS DE LA FICHA TÉCNICA === -->
    <!-- ========================================== -->
    <TechnicalData :id-design="design.idDesign">
<!--      <InputWrapper :label="$t('lang.msg.baseColor')">-->
<!--        <span>{{ getLangValue(design, 'baseColor') }}</span>-->
<!--      </InputWrapper>-->
<!--      <InputWrapper :label="$t('lang.msg.size')">-->
<!--        <span>{{ design.size }}</span>-->
<!--      </InputWrapper>-->
        <InputWrapper :label="$t('lang.msg.baseColor')" content="input">
            <Select
                id="baseColorEs"
                :data="baseColors"
                :track-by="getLangLabel('baseColor')"
                v-model="colorSelected"
            />
        </InputWrapper>
        <InputWrapper :label="$t('lang.msg.size')" content="input">
            <Select
                id="size"
                :data="sizes"
                track-by="size"
                v-model="sizeSelected"
                :value="design.idSize"
            />
        </InputWrapper>
    </TechnicalData>
      <br>

      <!-- === FOTOS === -->
      <section class="bg-white mt-8 pb-8">
          <div class="pointer  pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide" v-on:click="collapse('images')">
              <h2>Fotos</h2>
              <span :class="{'toggled':collapsed.images}">▲</span>
          </div>
          <div class="bg-white p-4 md:p-8 space-y-6" v-if="collapsed.images">
          <div class="grid grid-cols-1 xl:grid-cols-2 gap-2">
              <div>
                  <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
                      <h2>{{ $t("lang.msg.referencePhotos") }}</h2>
                  </div>
                  <vue-dropzone
                      ref="referenceDropzone"
                      id="referenceDropzone"
                      :options="dropzoneOptions"
                      @vdropzone-sending="sendingEventReferencia"
                  />

                  <div class="gallery">
                      <ImageGallery
                          v-for="(image, imageIndex) in design.referenceImages"
                          :key="`image_${imageIndex}`"
                          :url="image.ruta"
                          :id-foto="image.idFoto"
                          @image-deleted="referenceImageDeleted"
                      />
                  </div>
              </div>
              <div>
                  <div class="px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t">
                      <h2>{{ $t("lang.msg.filePhotos") }}</h2>
                  </div>
                  <vue-dropzone
                      ref="fileDropzone"
                      id="fileDropzone"
                      :options="dropzoneOptions"
                      @vdropzone-sending="sendingEventFoto"
                  />
                  <div class="gallery">
                      <ImageGallery
                          v-for="(image, imageIndex) in design.fileImages"
                          :key="`image_${imageIndex}`"
                          :url="image.ruta"
                          :id-foto="image.idFoto"
                          @image-deleted="fileImageDeleted"
                      />
                  </div>
              </div>
          </div>
          <div class="flex justify-center mt-8">
              <ButtonRedirect
                  v-if="hasRoles(['ADMIN', 'DIRECCIÓN', 'EQUIPO EUROPROSEM'])"
                  route="shipmentDesignControl"
                  :params="{ idDesign: design.idDesign }"
                  color="blue"
                  small
              >
                  Ver envío altas
              </ButtonRedirect>
          </div>
          </div>
      </section>
      <br>

      <!-- ============ -->
      <!-- === TAGS === -->
      <!-- ============ -->
      <Tags
          @change="onTagChange"
          v-model="design.tags"
          :id-comercial-request="comercialRequest.idComercialRequest"
      />
      <br>

      <!-- =============== -->
    <!-- === FÁBRICA === -->
    <!-- =============== -->
    <section>
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide" v-on:click="collapse('factory')">
        <h2>{{ $t("lang.msg.factory") }}</h2>
          <span :class="{'toggled':collapsed.factory}">▲</span>
      </div>

      <div v-if="collapsed.factory" class="bg-white p-4 md:p-8 space-y-8">
        <!-- =========================== -->
        <!-- === GRID CAMPOS FÁBRICA === -->
        <!-- =========================== -->
        <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8 xl:gap-4">
          <div class="space-y-4">
            <InputWrapper :label="$t('lang.msg.factoryShipmentDate')" content="input">
              <v-date-picker
                v-model="factoryData.fechaEnvioFabrica"
                mode="single"
                title-position="left"
                :input-props="{
                  class: 'datepicker hover:border-blue-500',
                  placeholder: $t('lang.msg.factoryShipmentDate'),
                }"
              />
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.realDateOfArrival')" content="input">
              <InputText v-model="sample.sampleDeliveredDate" disabled />
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.estimatedDateOfArrival')" content="input">
              <v-date-picker
                v-model="factoryData.fechaEstimadaLlegada"
                mode="single"
                title-position="left"
                :input-props="{
                  class: 'datepicker hover:border-blue-500',
                  placeholder: $t('lang.msg.estimatedDateOfArrival'),
                }"
              />
            </InputWrapper>
          </div>

          <div class="space-y-4">
            <InputWrapper :label="$t('lang.msg.orderedUnits')" content="input">
              <InputText v-model.number="factoryData.unidadesPedidas" :name="$t('lang.msg.orderedUnits')" />
            </InputWrapper>
            <InputWrapper :label="$t('lang.msg.laboratory')" content="input">
              <Select
                id="idLaboratory"
                :data="laboratories"
                track-by="laboratoryName"
                v-model.number="factoryData.idLaboratory"
              />
            </InputWrapper>

              <InputWrapper :label="$t('lang.msg.paymentMethod')" content="input">
                  <Select
                      id="idFormaPago"
                      :data="formasPago"
                      :track-by="getLangLabel('pagoNombre')"
                      v-model.number="factoryData.idFormaPago"
                  />
              </InputWrapper>
          </div>

          <InputWrapper :label="$t('lang.msg.description')" content="input" block>
            <textarea
              rows="3"
              class="form-textarea w-full mt-1"
              v-model="comercialRequest.comercialRequestConcept"
              :placeholder="$t('lang.msg.description')"
            />
          </InputWrapper>
        </div>

        <!-- ====================== -->
        <!-- === TAREAS FÁBRICA === -->
        <!-- ====================== -->
        <div class="space-y-6">
          <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[0]" receivers="PLANIFICACIÓN / DIRECCIÓN / LOGÍSTICA">
            <InputWrapper :label="$t('lang.msg.factoryAgent')" content="input" block>
              <Select
                id="factoryAgentName"
                :data="factoryAgents"
                track-by="factoryAgentName"
                v-model.number="sampleTasks[0].contenido"
              />
            </InputWrapper>
          </TaskWrapper>

          <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[1]" receivers="PLANIFICACIÓN / DIRECCIÓN / LOGÍSTICA">
            <InputWrapper :label="$t('lang.msg.factory')" content="input" block>
              <Select
                id="factoryName"
                :data="factories"
                track-by="factoryName"
                v-model.number="sampleTasks[1].contenido"
                @change="factoryChanged"
              />
            </InputWrapper>
          </TaskWrapper>

          <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[2]" receivers="PLANIFICACIÓN / DIRECCIÓN / LOGÍSTICA">
            <InputWrapper :label="$t('lang.msg.factoryLocation')" content="input" block>
              <InputText v-model="sampleTasks[2].contenido" :name="$t('lang.msg.factoryLocation')" />
            </InputWrapper>
          </TaskWrapper>

          <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[3]" receivers="PLANIFICACIÓN / DIRECCIÓN / LOGÍSTICA">
            <InputWrapper :label="$t('lang.msg.icoterm')" content="input" block>
              <Select
                id="name"
                :data="icoterms"
                track-by="name"
                v-model="sampleTasks[3].contenido"
              />
            </InputWrapper>
          </TaskWrapper>
        </div>
        <!-- ================== -->
        <!-- ===  PROCESSES === -->
        <!-- ================== -->
        <ProductionProcesses v-if="factorySelected" :id-factory="sample.idFactory" :id-sample="idSample" />

        <!-- ===================== -->
        <!-- === SUBSTRUCTURES === -->
        <!-- ===================== -->
        <ProductionSubstructures v-if="factorySelected" :id-factory="sample.idFactory" :id-sample="idSample" />
      </div>
    </section>
      <br>

    <!-- ============== -->
    <!-- === PRECIO === -->
    <!-- ============== -->
    <section>
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide" v-on:click="collapse('cost')">
        <h2>{{ $t("lang.msg.price") }}</h2>
          <span :class="{'toggled':collapsed.cost}">▲</span>
      </div>

      <div v-if="collapsed.cost" class="bg-white p-4 md:p-8 space-y-8">
        <div class="bg-white space-y-6">
          <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[4]" receivers="DIRECCIÓN">
            <InputWrapper :label="$t('lang.msg.costPrice')" content="input" block>
              <InputNumber type="currency" v-model="sampleTasks[4].contenido" :name="$t('lang.msg.costPrice')">
                <template slot="currency">
                  <InputNumberCurrency v-model="sampleTasks[4].divis" />
                </template>
              </InputNumber>
            </InputWrapper>
          </TaskWrapper>

          <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[5]" receivers="DIRECCIÓN">
            <InputWrapper :label="$t('lang.msg.clientSalePrice')" content="input" block>
              <InputNumber type="currency" v-model="sampleTasks[5].contenido" :name="$t('lang.msg.clientSalePrice')">
                <template slot="currency">
                  <InputNumberCurrency v-model="sampleTasks[5].divis" />
                </template>
              </InputNumber>
            </InputWrapper>
          </TaskWrapper>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <ButtonRedirect route="shipmentDesignControl" :params="{ idDesign: design.idDesign }">
            Ver envío altas
          </ButtonRedirect>
          <ButtonRedirect route="orderData" :params="{ idSample: idSample, idComercialRequest: comercialRequest.idComercialRequest }">
            {{ $t("lang.msg.officialOrderData") }}
          </ButtonRedirect>
          <ButtonRedirect route="escandallosCR" :params="{ idComercialRequest: comercialRequest.idComercialRequest }">
            Ver escandallos
          </ButtonRedirect>
          <ButtonRedirect route="newEscandalloDetail" :params="{ idSample: this.idSample }" v-if="hasRoles(['ADMIN','DIRECCIÓN', 'EQUIPO EUROPROSEM'])">
            Crear escandallo
          </ButtonRedirect>
        </div>
      </div>
    </section>
      <br>

    <!-- ================ -->
    <!-- === LICENCIA === -->
    <!-- ================ -->
    <section>
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide" v-on:click="collapse('license')">
        <h2>{{ $t("lang.msg.license") }}</h2>
          <span :class="{'toggled':collapsed.cost}">▲</span>
      </div>

      <div v-if="collapsed.license" class="bg-white p-4 md:p-8 space-y-6">
        <div class="flex flex-wrap lg:flex-no-wrap items-center space-x-0 lg:space-x-6 ">
          <div class="flex space-x-6">
            <label class="inline-flex items-center">
              <input
                v-model="sample.licenseType"
                type="radio"
                class="form-radio"
                value="directa"
              >
              <span class="ml-2 cursor-pointer">{{ $t("lang.msg.direct") }}</span>
            </label>
            <label class="inline-flex items-center ml-6">
              <input
                v-model="sample.licenseType"
                type="radio"
                class="form-radio"
                value="indirecta"
              >
              <span class="ml-2 cursor-pointer">{{ $t("lang.msg.indirect") }}</span>
            </label>
            <label class="inline-flex items-center ml-6">
              <input
                v-model="sample.licenseType"
                type="radio"
                class="form-radio"
                value="No Aplica"
              >
              <span class="ml-2 cursor-pointer">{{ $t("lang.msg.notApplicable") }}</span>
            </label>
          </div>
          <div class="mt-4 lg:mt-0">
            <ButtonAction @action="addOtherRight">
              {{ $t('lang.msg.add') }}
            </ButtonAction>
            <span class="ml-2">Otros derechos</span>
          </div>
        </div>

        <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[6]" receivers="LICENCIA / DIRECCIÓN">
          <InputWrapper :label="$t('lang.msg.license')" content="input" block>
            <InputText v-model="sampleTasks[6].contenido" :name="$t('lang.msg.license')" :disabled="doesNotApply" />
          </InputWrapper>
        </TaskWrapper>
        <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[7]" receivers="LICENCIA / DIRECCIÓN">
          <InputWrapper :label="$t('lang.msg.property')" content="input" block>
            <InputText v-model="sampleTasks[7].contenido" :name="$t('lang.msg.property')" :disabled="doesNotApply" />
          </InputWrapper>
        </TaskWrapper>
        <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[8]" receivers="LICENCIA / DIRECCIÓN">
          <InputWrapper :label="$t('lang.msg.licenseAgent')" content="input" block>
            <InputText v-model="sampleTasks[8].contenido" :name="$t('lang.msg.licenseAgent')" :disabled="doesNotApply" />
          </InputWrapper>
        </TaskWrapper>
        <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[9]" receivers="LICENCIA / DIRECCIÓN">
          <div>
            <label class="block text-sm leading-5 font-medium text-gray-700">DEAL</label>
            <div class="mt-2 flex">
              <label class="inline-flex items-center">
                <input
                  v-model="sampleTasks[9].oferta"
                  type="radio"
                  class="form-radio"
                  :value="true"
                  :disabled="doesNotApply || sample.licenseType==='directa'"
                >
                <span class="ml-2 cursor-pointer">OK</span>
              </label>
              <label class="inline-flex items-center ml-6">
                <input
                  v-model="sampleTasks[9].oferta"
                  type="radio"
                  class="form-radio"
                  :value="false"
                  :disabled="doesNotApply || sample.licenseType==='directa'"
                >
                <span class="ml-2 cursor-pointer">NO</span>
              </label>
            </div>
          </div>
        </TaskWrapper>
        <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[10]" receivers="LICENCIA / DIRECCIÓN">
          <InputWrapper label="Royalty %" content="input" block>
            <InputText v-model="sampleTasks[10].contenido" name="Royalty %" :disabled="doesNotApply || sample.licenseType==='directa'" />
          </InputWrapper>
        </TaskWrapper>
        <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[11]" receivers="LICENCIA / DIRECCIÓN">
          <InputWrapper label="MG/FEE" content="input" block>
              <InputNumber
                  type="currency"
                  v-model="sampleTasks[11].contenido"
                  name="MG/FEE"
                  :disabled="doesNotApply || sample.licenseType==='directa'">
                  <template slot="currency" v-if="sample.licenseType!=='directa'">
                      <InputNumberCurrency v-model="sampleTasks[11].divis" />
                  </template>
              </InputNumber>
          </InputWrapper>
        </TaskWrapper>
        <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[12]" receivers="LICENCIA / DIRECCIÓN">
          <InputWrapper label="PTE. STATUS LIC." content="input" block>
            <InputText v-model="sampleTasks[12].contenido" name="PTE. STATUS LIC." :disabled="doesNotApply" />
          </InputWrapper>
        </TaskWrapper>

        <TaskWrapperOthers
          v-for="(otherRight, rightIndex) in otherRights"
          :key="`otherRight_${rightIndex}`"
          :other-right="otherRight"
          receivers="LICENCIA / DIRECCIÓN"
        >
          <div class="rounded-md">
            <input
              type="text"
              v-model="otherRight.nombre"
              placeholder="Texto"
              :disabled="doesNotApply"
              class="appearance-none rounded-none relative block w-full h-8 px-3 py-2 border border-gray-500 placeholder-gray-500 rounded-t focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
            >
            <div class="relative -mt-px">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span v-if="otherRight.divis == 'EUR'" class="text-gray-500 sm:text-sm sm:leading-5">€</span>
                <span v-if="otherRight.divis == 'USD'" class="text-gray-500 sm:text-sm sm:leading-5">$</span>
                <span v-if="otherRight.divis == 'GBP'" class="text-gray-500 sm:text-sm sm:leading-5">£</span>
                <span v-if="otherRight.divis == 'CNY'" class="text-gray-500 sm:text-sm sm:leading-5">¥</span>
              </div>
              <input
                type="text"
                ref="inputnumber"
                inputmode="numeric"
                pattern="[0-9]+([,\.][0-9]+)?"
                v-model.number="otherRight.precio"
                class="block w-full appearance-none h-8 py-2 pl-7 pr-12 border border-gray-500 placeholder-gray-500 rounded-b focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                placeholder="0.00"
                :disabled="doesNotApply"
              >
              <div class="absolute inset-y-0 right-0 flex items-center">
                <select v-model="otherRight.divis" class="form-select h-full py-0 pl-2 pr-7 border-transparent bg-transparent text-gray-500 sm:text-sm sm:leading-5">
                  <option value="USD">
                    USD
                  </option>
                  <option value="GBP">
                    GBP
                  </option>
                  <option value="EUR">
                    EUR
                  </option>
                  <option value="CNY">
                    CNY
                  </option>
                </select>
              </div>
            </div>
          </div>
        </TaskWrapperOthers>
      </div>
    </section>
      <br>

    <!-- =========== -->
    <!-- === RSC === -->
    <!-- =========== -->
    <RSC
      v-if="factorySelected && hasRoles(['ADMIN', 'DIRECCIÓN', 'EQUIPO EUROPROSEM'])"
      :tasks="rscTasks"
      :id-sample="idSample"
      :id-factory="sample.idFactory"
    />
      <br>

    <!-- ====================== -->
    <!-- === CERTIFICATIONS === -->
    <!-- ====================== -->
    <Certifications v-if="factorySelected && hasRoles(['ADMIN', 'DIRECCIÓN', 'EQUIPO EUROPROSEM'])" :id-sample="idSample" />
      <br>

    <!-- ==================== -->
    <!-- === OTROS COSTOS === -->
    <!-- ==================== -->
    <section>
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide" v-on:click="collapse('other')">
        <h2>{{ $t("lang.msg.otherCosts") }}</h2>
        <span :class="{'toggled':collapsed.other}">▲</span>
      </div>

      <div v-if="collapsed.other" class="bg-white p-4 md:p-8 space-y-8">
        <div class="bg-white space-y-6">
          <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[13]" receivers="RSC / DIRECCIÓN / LOGÍSTICA">
            <InputWrapper :label="$t('lang.msg.labCosts')" content="input" block>
              <InputNumber type="currency" v-model="sampleTasks[13].contenido" :name="$t('lang.msg.labCosts')">
                <template slot="currency">
                  <InputNumberCurrency v-model="sampleTasks[13].divis" />
                </template>
              </InputNumber>
            </InputWrapper>
          </TaskWrapper>

          <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[14]" receivers="RSC / DIRECCIÓN / LOGÍSTICA">
            <InputWrapper :label="$t('lang.msg.auditCosts')" content="input" block>
              <InputNumber type="currency" v-model="sampleTasks[14].contenido" :name="$t('lang.msg.auditCosts')">
                <template slot="currency">
                  <InputNumberCurrency v-model="sampleTasks[14].divis" />
                </template>
              </InputNumber>
            </InputWrapper>
          </TaskWrapper>

          <TaskWrapper v-if="sampleTasks.length > 0" :task="sampleTasks[15]" receivers="RSC / DIRECCIÓN / LOGÍSTICA">
            <InputWrapper :label="$t('lang.msg.logisticCosts')" content="input" block>
              <InputNumber type="currency" v-model="sampleTasks[15].contenido" :name="$t('lang.msg.logisticCosts')">
                <template slot="currency">
                  <InputNumberCurrency v-model="sampleTasks[15].divis" />
                </template>
              </InputNumber>
            </InputWrapper>
          </TaskWrapper>
        </div>
      </div>
    </section>
      <br>

    <!-- =================== -->
    <!-- === COMENTARIOS === -->
    <!-- =================== -->
    <section>
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide rounded-t mt-8" v-on:click="collapse('comments')">
        <h2>{{ $t("lang.msg.comments") }}</h2>
          <span :class="{'toggled':collapsed.comments}">▲</span>
      </div>
      <Comments
          v-if="collapsed.comments"
        class="p-4 md:p-8"
        :comments="sample.comen"
        @comment-added="commentAdded"
        :id-comercial-request="comercialRequest.idComercialRequest"
      />
    </section>
      <br>

    <!-- ===================== -->
    <!-- === ASIGNAR TAREA === -->
    <!-- ===================== -->
    <section>
      <div class="pointer px-4 md:px-8 text-lg font-semibold bg-secundario text-primario tracking-wide" v-on:click="collapse('tasks')">
        <h2>{{ $t("lang.msg.assignTask") }}</h2>
          <span :class="{'toggled':collapsed.tasks}">▲</span>
      </div>
      <TaskAssign
          v-if="collapsed.tasks"
          :id-origen-tarea="sample.idSample"
          origen-tarea="sample"
          :referencia="referencia" />
    </section>
      <br>

    <!-- ============== -->
    <!-- === FOOTER === -->
    <!-- ============== -->
    <section class="mt-8">
      <div class="bg-white p-4 md:p-8 space-y-2 rounded-sm">
        <div class="flex flex-col md:flex-row justify-end space-y-2 md:space-y-0 space-x-0 md:space-x-4">
          <div class="w-full md:w-56">
            <ButtonAction @action="cloneSample" large>
              {{ $t("lang.msg.cloneSample") }}
            </ButtonAction>
          </div>
          <div class="w-full md:w-56">
            <ButtonAction @action="() => isDiscontinueModalOpen = true" large>
              {{ $t("lang.msg.deleteSample") }}
            </ButtonAction>
          </div>
        </div>
        <div class="flex flex-col lg:flex-row lg:items-center items-start justify-between">
            <div class="flex ml-auto">
                <div>
                    <Steps
                            :comercialToDesign="comercialRequest.comercialToDesign"
                            :designToSample="design.designToSample"
                            :sampleToProduction="sample.sampleToProduction"
                        />
                </div>
            </div>
            <div class="flex flex-col">
                <div>
                    <input
                        v-model="comercialRequest.comercialToDesignDate"
                        class="form-input w-full md:w-56 h-8 mr-4"
                        type="text"
                        disabled
                        name="comercialToDesignDate"
                    >
                    <input
                        v-model="comercialRequest.comercialToDesignUserName"
                        class="form-input w-full md:w-56 h-8"
                        type="text"
                        disabled
                    >
                </div>
                <div class="mt-6">
                    <input
                        v-model="design.designToSampleDate"
                        class="form-input w-full md:w-56 h-8 mr-4"
                        type="text"
                        disabled
                    >
                    <input
                        v-model="design.designToSampleUserName"
                        class="form-input w-full md:w-56 h-8"
                        type="text"
                        disabled
                    >
                </div>
                <div class="mt-6">
                    <input
                        v-model="sample.sampleToProductionDate"
                        type="text"
                        class="form-input w-full md:w-56 h-8 mr-4"
                        disabled
                    >
                    <input
                        v-model="sample.sampleToProductionUserName"
                        type="text"
                        class="form-input w-full md:w-56 h-8"
                        disabled
                    >
                </div>
                <div class="mt-6">
                    <ToggleButton :checked="sample.sampleToProduction" @change="toggleSampleToProduction">
                        {{ $t("lang.msg.sampleToProduction") }}
                    </ToggleButton>
                </div>
                </div>
          <div class="flex items-center my-2 lg:my-0 text-sm">
          </div>
          <div class="w-full md:w-auto my-2 md:my-0 space-y-4 md:space-y-0 space-x-0 md:space-x-4">
          </div>
        </div>
        <div class="flex flex-col lg:flex-row lg:items-center items-start justify-between">
          <div class="flex items-center my-2 lg:my-0 text-sm">
            <ToggleButton :checked="sample.sampleDelivered" @change="toggleIsSampleReceived">
              {{ $t("lang.msg.sampleReceived") }}
            </ToggleButton>
          </div>
          <div class="w-full md:w-auto my-2 md:my-0 space-y-4 md:space-y-0 space-x-0 md:space-x-4">
            <input
              v-model="sample.sampleDeliveredDate"
              type="text"
              class="form-input w-full md:w-56 h-8"
              disabled
            >
            <input
              v-model="sample.sampleDeliveredUserName"
              type="text"
              class="form-input w-full md:w-56 h-8"
              disabled
            >
          </div>
        </div>
        <div class="flex flex-col lg:flex-row lg:items-center items-start justify-between">
          <div class="flex items-center my-2 lg:my-0 text-sm">
            <ToggleButton :checked="sample.purchaseIntent" @change="toggleSampleWithPurchaseIntent">
              {{ $t("lang.msg.sampleToBuy") }}
            </ToggleButton>
          </div>
          <div class="w-full md:w-auto my-2 md:my-0 space-y-4 md:space-y-0 space-x-0 md:space-x-4">
            <input
              v-model="sample.purchaseIntentDate"
              type="text"
              class="form-input w-full md:w-56 h-8"
              disabled
            >
            <input
              v-model="sample.purchaseIntentUserName"
              type="text"
              class="form-input w-full md:w-56 h-8"
              disabled
            >
          </div>
        </div>
        <div class="flex flex-col lg:flex-row lg:items-center items-start justify-between">
          <div class="flex items-center my-2 lg:my-0 text-sm">
          </div>
          <div class="w-full md:w-auto my-2 md:my-0 space-y-4 md:space-y-0 space-x-0 md:space-x-4">
          </div>
        </div>
        <div class="flex justify-end space-y-2">
          <div class="w-full md:w-56">
            <ButtonAction @action="confirmUpdateSampleModal=true" large>
               <span style="color:white;display:flex;flex-direction:row;align-items: center;justify-content:center;padding: 0.5em">
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="28"
                    fill="white"
                    viewBox="0 0 24 28">
                    <path d="M6 24h12v-6h-12v6zM20 24h2v-14c0-0.297-0.266-0.938-0.469-1.141l-4.391-4.391c-0.219-0.219-0.828-0.469-1.141-0.469v6.5c0 0.828-0.672 1.5-1.5 1.5h-9c-0.828 0-1.5-0.672-1.5-1.5v-6.5h-2v20h2v-6.5c0-0.828 0.672-1.5 1.5-1.5h13c0.828 0 1.5 0.672 1.5 1.5v6.5zM14 9.5v-5c0-0.266-0.234-0.5-0.5-0.5h-3c-0.266 0-0.5 0.234-0.5 0.5v5c0 0.266 0.234 0.5 0.5 0.5h3c0.266 0 0.5-0.234 0.5-0.5zM24 10v14.5c0 0.828-0.672 1.5-1.5 1.5h-21c-0.828 0-1.5-0.672-1.5-1.5v-21c0-0.828 0.672-1.5 1.5-1.5h14.5c0.828 0 1.969 0.469 2.562 1.062l4.375 4.375c0.594 0.594 1.062 1.734 1.062 2.562z"></path>
                </svg>
                <span class="md:ml-1">
              {{ $t("lang.msg.save") }}
                </span>
                </span>
            </ButtonAction>
          </div>
        </div>
      </div>
    </section>
      <br>

    <!-- ========================= -->
    <!-- === MODAL DESCATALOGO === -->
    <!-- ========================= -->
    <TheModal :open="isDiscontinueModalOpen" @close="isDiscontinueModalOpen = false" :title="$t('lang.msg.discontinue')">
      <template #body>
        <p class="mt-4 pr-16 text-gray-700 font-semibold">
          {{ $t('lang.msg.discontinueSample') }}
        </p>
        <textarea
          rows="2"
          class="form-textarea w-full mt-2"
          placeholder="Escriba el motivo aquí"
          v-model="cancellationReason"
        />
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 hover:bg-green-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click.once="discontinueSample"
          >{{ $t('lang.msg.discontinue') }}</button>
        </span>
      </template>
    </TheModal>
    <TheModal
        :open="confirmUpdateSampleModal"
        :title="$t('lang.msg.nextStep')"
        @close="confirmUpdateSampleModal=false"
    >
      <template #body>
        ¿Guardar la muestra?
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 hover:bg-green-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
              @click="updateSample">Aceptar</button>
        </span>
      </template>
    </TheModal>
  </form>
</template>

<script>
// MIXINS
import CalendarMixin from "@/components/mixins/CalendarMixin";
import UtilsMixin from "@/components/mixins/UtilsMixin";

import PlanningDays from "@/components/shared/planning/PlanningDays";

// SECTIONS
import TechnicalData from "@/components/shared/sections/TechnicalData";
import Comments from "@/components/Comments";
import TaskAssign from "@/components/TaskAssign";
import RSC from "@/components/shared/sections/RSC";
import Certifications from "@/components/shared/sections/Certifications";

// MODAL
import TheModal from "@/components/shared/TheModal";
import InputNumber from "@/components/core-ui/InputNumber";

// DROPZONE
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import Tags from "@/components/shared/sections/Tags";
import Steps from "@/components/Steps";

export default {
  name: "NewSample",
  components: {
      Steps,
      InputNumber,
    PlanningDays,
    TechnicalData,
    Comments,
    TaskAssign,
    TheModal,
    RSC,
    Certifications,
      vueDropzone: vue2Dropzone,
      Tags
  },
  mixins: [CalendarMixin, UtilsMixin],
  data() {
    return {
        sizeSelected:0,
        colorSelected:0,
      sample: {
        purchaseIntentUserName: "",
        sampleToProductionUserName: "",
        sampleDeliveredUserName: "",
        licenseType: "directa"
      },
      design: {
        idDesign: 0
      },
      comercialRequest: {
        idComercialRequest: 0
      },
      // TASKS
      sampleTasks: [],
      rscTasks: [],
      factoryData: {
        idCertificate: null,
        idLaboratory: null
      },
      certificates: [],
      laboratories: [],
      factoryAgents: [],
      factories: [],
      icoterms: [],
      otherRights: [],
      factorySelected: false,
      dropzoneOptions: {
          timeout: 120000,
          maxFilesize: 2048,
          url: `${this.$API_URL}/api/FileUpload/FotoReferenciaFichaUpload`,
          thumbnailWidth: 175,
          thumbnailHeight: 175,
          paramName: "files"
      },
      // MODAL
      isDiscontinueModalOpen: false,
      cancellationReason: "",
      // GENERAL DATA
      employees: [],
      buyers: [],
      clients: [],
      designers: [],
      collections: [],
      seasons: [],
      subfamilyArticles: [],
      sections: [],
      baseColors:[],
      sizes:[],
      // FILTERS
      filteredBuyers: [],
      filteredDesigners: [],
      // VALIDATIONS
      formHasErrors: false,
      collapsed:{
          general:true,
          images:true,
          factory:true,
          cost:true,
          license:true,
          other:true,
          comments:true,
          tasks:true
      },
      confirmUpdateSampleModal:false,
      formasPago:[]
    };
  },
  computed: {
    referencia() {
      return (
        this.comercialRequest.comercialRequestReference + '' +
        this.comercialRequest.comercialRequestReferenceNumber
      );
    },
    doesNotApply() {
      return this.sample.licenseType == 'No Aplica';
    }
  },
  created() {
    window.scrollTo(0, 0);
    this.idSample = parseInt(this.$route.params.idSample);

    this.fetchGeneralData();
    this.fetchData();
    this.fetchSampleTasks();
    this.fetchSampleRSCTasks();
    this.fetchTareasFabrica();
    this.fetchCertificates();
    this.fetchLaboratories();
    this.fetchFactories();
    this.fetchAgents();
    this.fetchIcoterms();
    this.fetchOtherRights();
  },
  methods: {
      collapse(section){
          this.collapsed[section]=!this.collapsed[section];
      },
    fetchData() {
      // Find the 'Sample' by its 'idSample'.
      this.$axios
        .post(`api/Samples/GetSample`, {
          idSample: this.idSample
        })
        .then((response) => {
          this.sample = response.data[0];

          // Format the dates we got from the server.
          this.formatDateToString(this.sample, [
            "purchaseIntentDate",
            "sampleToProductionDate",
            "sampleDeliveredDate"
          ]);

          this.fetchComercialAndDesign();
        });
    },
    async fetchComercialAndDesign() {
      let params = {
        idComercialRequest: this.sample.idComercialRequest
      };

      Promise.all([
        this.$axios.post(`api/ComercialRequests/GetThisComerRequest`, params),
        this.$axios.post(`api/Comments/GetAllComment`, params),
        await this.$axios.post(`api/Designs/GetDesign`, {
          idDesign: this.sample.idDesign
        }),
        await this.$axios.post(`api/Sizes/GetSize`, params),
        this.$axios.post(`api/Tags/GetAllTag`, params)


      ]).then((values) => {
        this.comercialRequest = values[0].data[0];
        this.sample.comen = values[1].data || [];
        this.design = values[2].data[0];
        this.sizeSelected = values[2].data[0].size;
        this.colorSelected = values[2].data[0].baseColorEs;

          // Formateamos las fechas de solicitud comercial y diseño.
        this.formatDateToString(this.design, [ "designToSampleDate" ]);
        this.formatDateToString(this.comercialRequest, [ "comercialToDesignDate" ]);
        this.sizes = values[3].data.filter((el) => {
            return el.active && el.subfamilyArticleEs == values[2].data[0].subfamilyArticleEs;
        });
        this.design.tags = values[4].data || [];
        this.fetchImages();
      });
    },
    fetchSampleTasks() {
      this.$axios
        .post(`api/SampleTasks/GetThisSampleTask`, {
          idSample: this.idSample
        })
        .then((response) => {
          let tasks = response.data;
          // Array with idSampleTaskSample that have currencies.
          let samplesWithCurrency = [4, 5, 13, 14, 15];

          tasks.forEach((element) => {
            // Formateamos la fecha de cada una de las tareas.
            this.formatDatetimesToDates(element, [
              "sampleTaskSampleResolutionDate"
            ]);

            // Recoger divisa de la tarea si es un campo moneda (samplesWithCurrency es un array de los ids de las tareas).
            if (samplesWithCurrency.includes(element.idSampleTask)) {
              this.fetchSampleTaskCurrency(element);
            }
          });

          // Check if the factory task is filled to show RSC sections.
          this.factorySelected = tasks[1].contenido != null;
          this.sampleTasks = tasks;
        });
    },
    fetchSampleRSCTasks() {
      this.$axios.post(`api/Samples/PostRSCTaskSample`, {
        idSample: this.idSample
      }).then((response) => {
        this.rscTasks = response.data;
      });
    },
    fetchCertificates() {
      this.$axios.get(`api/Certificats/GetCertificatActive`).then((response) => {
        this.certificates = response.data;
      });
    },
    fetchLaboratories() {
      this.$axios.get(`api/Laboratories/GetLaboratory`).then((response) => {
        this.laboratories = this.getActive(response.data, 'active');
      });
    },
    fetchTareasFabrica() {
      this.$axios
        .post(`api/TareaFabricas/GetAll`, {
          idSample: this.idSample
        })
        .then((response) => {
          this.factoryData = response.data[0];

          this.formatDatetimesToDates(this.factoryData, [
            "fechaEnvioFabrica",
            "fechaEstimadaLlegada",
            "fechaLlegadaReal"
          ]);
        });
    },
    fetchFactories() {
      this.$axios.get("api/DocumentCertificats/ComboFactory").then((response) => {
        this.factories = response.data;
      });
    },
    fetchAgents() {
      this.$axios.get(`api/FactoryAgents/GetFactoryAgent`).then((response) => {
        this.factoryAgents = this.getActive(response.data, 'active');
      });
    },
    fetchIcoterms() {
      this.$axios.get("api/Icoterms/GetIcoterm").then((response) => {
        this.icoterms = this.getActive(response.data, 'active');
      });
    },
    /**
     *  The function will load first every data needed.
     */
    fetchGeneralData() {
      let langParams = { lang: this.language };

      Promise.all([
        this.$axios.post(`api/Employees/GetBy`, {
          rolName: "COMERCIAL",
          lang: this.language
        }),
        this.$axios.get(`api/Buyers/GetAllBuyer`),
        this.$axios.get(`api/Clients/GetAllClient`),
        this.$axios.get(`api/Designers/GetDesigner`),
        this.$axios.post(`api/Collections/GetCollectionActive`, langParams),
        this.$axios.post(`api/Seasons/GetSeason`, langParams),
        this.$axios.post(`api/SubfamilyArticles/getSubfamilyArticle`, langParams),
        this.$axios.get(`api/Sections/getSection`),
        this.$axios.post(`api/BaseColors/GetBaseColor`, langParams),
        this.$axios.get(`api/FormaPagoes/GetAll`)
      ])
        .then((values) => {
          this.employees = this.getActive(values[0].data, 'active');
          this.buyers = this.getActive(values[1].data, 'active');
          this.clients = this.getActive(values[2].data, 'active');
          this.designers = this.getActive(values[3].data, 'active');
          this.collections = this.getActive(values[4].data, 'collectionAction');
          this.seasons = this.getActive(values[5].data, 'seasonActive');
          this.subfamilyArticles = this.getActive(values[6].data, 'subfamilyArticleActive');
          this.sections = this.getActive(values[7].data, 'active');
          this.baseColors = this.getActive(values[8].data, 'active');
          this.formasPago = this.getActive(values[9].data, 'active');
        });
    },
    /**
     *  Sets the employee and modifies the idCompany variable.
     */
    changeEmployee(idEmployee) {
      if (idEmployee) {
        let employee = this.employees.find((el) => {
          return el.idEmployee == idEmployee;
        });

        this.$set(this.comercialRequest, "idCompany", employee.idCompany);
      }
    },
    /**
     *  Filters the 'Buyers' and 'Designers' when the 'Client' is selected.
     */
    filterPerClient(idClient) {
      if (idClient) {
        this.filteredBuyers = this.buyers.filter((buyer) => {
          return buyer.idClient == idClient;
        });

        this.filteredDesigners = this.designers.filter((designer) => {
          return designer.idClient == idClient;
        });

        let clientFound = this.clients.find(client => {
          return client.idClient == idClient
        });

        if (clientFound) {
          this.$set(this.comercialRequest, 'groupName', clientFound.groupName);
        }
      }
    },
    sendingEventReferencia(file, xhr, formData) {
        formData.append("referencia", true);
        formData.append("idComercialRequest", this.comercialRequest.idComercialRequest);
    },
    referenceImageDeleted(idFoto) {
        let images = this.design.referenceImages.filter(image => {
            return image.idFoto != idFoto
        });
        this.$set(this.design, 'referenceImages', images);
        this.$forceUpdate();
    },
    sendingEventFoto(file, xhr, formData) {
        formData.append("referencia", false);
        formData.append("idComercialRequest", this.comercialRequest.idComercialRequest);
    },
    fileImageDeleted(idFoto) {
        let images = this.design.fileImages.filter(image => {
            return image.idFoto != idFoto
        });

        this.$set(this.design, 'fileImages', images);
        this.$forceUpdate();
    },
    onTagChange(array) {
        this.$set(this.design, "tags", array);
    },
    fetchImages() {
        this.$axios
            .post(`api/Fotoes/GetAllFoto`, {
                idComercialRequest: this.design.idComercialRequest
            })
            .then((response) => {
                let allImages = response.data;

                this.design.referenceImages = allImages.filter((element) => {
                    return element.referencia;
                });

                let fileImages = allImages.filter((element) => {
                    return element.referencia == false;
                });
                this.$set(this.design, "fileImages", fileImages);
            });
    },
    updateSample() {
        this.confirmUpdateSampleModal=false
      if (!this.comercialRequest.idClient) {
        this.formHasErrors = true;

        // Scroll to Input with errors.
        this.$nextTick(() => {
          window.scrollTo(0, this.$refs.idClient.$el.offsetTop - 300);
        });
      } else {
        // Clone the object to avoid formatting back and forth.
        let factoryDataClone = { ...this.factoryData };

        // Formateamos las fechas de fábrica
        this.formatDatesToDatetimes(factoryDataClone, [
          "fechaEnvioFabrica",
          "fechaEstimadaLlegada",
          "fechaLlegadaReal"
        ]);

        // Guardamos primero datos de fábrica.
        this.$axios.post(`api/TareaFabricas/Update`, factoryDataClone);

        // Hacemos un clon del objeto para no modificar las fechas originales.
        let sampleClone = { ...this.sample };

        // Formateamos las fechas de muestra a Datetime
        this.formatStringsToDates(sampleClone, [
          "purchaseIntentDate",
          "sampleDeliveredDate",
          "sampleToProductionDate"
        ]);

        this.$axios
          .post(`api/Samples/Update`, {
            idSample: this.idSample,
            idUser: this.user.id,
            idDesign: this.sample.idDesign,
            sampleDateSignUp: this.sample.sampleDateSignUp,
            purchaseIntent: this.sample.purchaseIntent,
            purchaseIntentDate: sampleClone.purchaseIntentDate,
            purchaseIntentUser: this.sample.purchaseIntentUser,
            sampleDelivered: this.sample.sampleDelivered,
            sampleDeliveredDate: sampleClone.sampleDeliveredDate,
            sampleDeliveredUser: this.sample.sampleDeliveredUser,
            sampleToProduction: this.sample.sampleToProduction,
            sampleToProductionDate: sampleClone.sampleToProductionDate,
            sampleToProductionUser: this.sample.sampleToProductionUser,
            completado: false,
            licenseType: this.sample.licenseType,
            fechaLlegadaReal: factoryDataClone.fechaLlegadaReal,
            fechaEstimadaLlegada: factoryDataClone.fechaEstimadaLlegada,
            fechaEnvioFabrica: factoryDataClone.fechaEnvioFabrica,
            idLaboratory: this.factoryData.idLaboratory,
            unidadesPedidas: this.factoryData.unidadesPedidas || 0,
            concepto: this.comercialRequest.comercialRequestConcept
          })
          .then(() => {
            // Actualizamos las tareas de muestra que tienen rellenado el campo contenido.
            this.sampleTasks.filter(task => {
              if (task.contenido != null || task.idSampleTask == 10) {
                this.updateSampleTask(task);
              }
            });

            // Actualizamos las tareas de otros derechos.
            this.otherRights.filter(otherRight => {
              this.updateOtherRights(otherRight);
            });

            // Hacemos un clon del objeto para no modificar las fechas originales.
            let CRClone = { ...this.comercialRequest };
            this.formatStringsToDates(CRClone, ["comercialToDesignDate"]);

            // === UPDATE GENERAL DATA ===
            this.$axios.post(`api/ComercialRequests/UpdateGeneral`, CRClone);

            this.openAlert("success", "Muestra actualizada", null);
          });
        this.$axios.post(`api/Designs/UpdateDesign`,{
            IdDesign: this.sample.idDesign,
            IdBaseColor:this.baseColors.find(c=>c.baseColorEs===this.colorSelected).idBaseColor,
            IdSize:this.sizes.find(s=>s.size===this.sizeSelected).idSize
        })
      }
    },
    fetchSampleTaskCurrency(sampleTask) {
      this.$axios.post(`api/Divisas/GetAll`, {
        idSampleTaskSample: sampleTask.idSampleTaskSample
      }).then(response => {
        let divisa = response.data[0] ? response.data[0].divis : 'EUR';

        // Adjuntar la divisa de la tarea ya que no está hecho como campo.
        this.$set(sampleTask, 'divis', divisa);
      });
    },
    fetchOtherRightsCurrency(otherRight) {
      this.$axios.post(`api/Divisas/GetAll`, {
        idOtrosDerechos: otherRight.idOtrosDerechos
      }).then(response => {
        let divisa = response.data[0] ? response.data[0].divis : 'EUR';

        // Adjuntar la divisa de la tarea ya que no está hecho como campo.
        this.$set(otherRight, 'divis', divisa);
      });
    },
    fetchOtherRights() {
      this.$axios
        .post("api/OtrosDerechos/GetThis", {
          idSample: this.idSample
        })
        .then((response) => {
          let data = response.data;

          data.forEach(element => {
            this.fetchOtherRightsCurrency(element);
          })

          this.otherRights = data;
        });
    },
    addOtherRight() {
      this.$axios
        .post("api/OtrosDerechos/Add", {
          idSample: this.idSample,
          idUser: this.user.id,
          fechaResolucion: "2020-01-01T00:00:00.000Z"
        })
        .then((response) => {
          this.otherRights.push(response.data[0]);
        });
    },
    updateSampleTask(sampleTask) {
      if (sampleTask.contenido != null && sampleTask.contenido != "" || sampleTask.idSampleTask == 10) {
        this.$set(sampleTask, "completa", true);
      } else {
        this.$set(sampleTask, "completa", false);
      }

      this.$axios
        .post("api/SampleTaskSamples/Update", {
          idSampleTaskSample: sampleTask.idSampleTaskSample,
          idSample: sampleTask.idSample,
          contenido: sampleTask.contenido,
          idUser: this.user.id,
          oferta: sampleTask.oferta,
          divis: sampleTask.divis,
          completa: sampleTask.completa
        })
        .then(() => {
          // Update 'ResolutionDate' after a succesful update.
          this.$set(sampleTask, "sampleTaskSampleResolutionDate", new Date());
        });
    },
    updateOtherRights(otherRight) {
      this.$axios
        .post("api/OtrosDerechos/Update", {
          idSample: otherRight.idSample,
          idUser: this.user.id,
          fechaResolucion: otherRight.fechaResolucion,
          nombre: otherRight.nombre,
          precio: otherRight.precio,
          idOtrosDerechos: otherRight.idOtrosDerechos,
          divis: otherRight.divis
        })
        .then(() => {
          this.$set(otherRight, "acabada", true);
          this.$set(otherRight, "fechaResolucion", new Date());
        });
    },
    factoryChanged(factoryName) {
      let itemSelected = this.factories.find((factory) => {
        return factory.factoryName == factoryName;
      });

      this.$set(this.sampleTasks[2], "contenido", itemSelected.factoryLocation);
      this.$set(this.sample, "idFactory", itemSelected.idFactory);
      this.factorySelected = true;
    },
    toggleIsSampleReceived(value) {
      this.checkSampleToggle(
        "sampleDeliveredDate",
        "sampleDeliveredUser",
        "sampleDeliveredUserName",
        "sampleDelivered",
        value
      );
    },
    toggleSampleWithPurchaseIntent(value) {
      this.checkSampleToggle(
        "purchaseIntentDate",
        "purchaseIntentUser",
        "purchaseIntentUserName",
        "purchaseIntent",
        value
      );

      if (value) {
        this.toggleSampleToProduction(false)
      }
    },
    toggleSampleToProduction(value) {
      this.checkSampleToggle(
        "sampleToProductionDate",
        "sampleToProductionUser",
        "sampleToProductionUserName",
        "sampleToProduction",
        value
      );

      if (value) {
        this.toggleSampleWithPurchaseIntent(false)
      }
    },
    /**
     *  Function that activates/deactivates one of the toggles from the Sample.
     */
    checkSampleToggle(date, idUser, userName, prop, value) {
      if (value) {
        this.$set(this.sample, date, this.getCurrentDateAndHour());

        // Set the user id and its fullname.
        this.$set(this.sample, idUser, this.user.id);
        this.$set(this.sample, userName, this.user.fullname);
      } else {
        // If it returns false, then we empty their values
        this.$set(this.sample, date, "");
        this.$set(this.sample, idUser, 0);
        this.$set(this.sample, userName, null);
      }

      this.$set(this.sample, prop, value);
    },
    cloneSample() {
      const year = this.$moment().format("YYYY");
      this.$axios
        .post("api/Clonations/ClonationSamples", {
          idSample: this.sample.idSample,
          idUser: this.user.id,
          designToSampleDate: year+"-01-01T00:00:00.000Z",
          comercialRequestDesignDelivery: year+"-01-01T00:00:00.000Z",
          comercialRequestNeededDate: year+"-01-01T00:00:00.000Z",
          comercialToDesignDate: year+"-01-01T00:00:00.000Z",
          purchaseIntentDate: year+"-01-01T00:00:00.000Z",
          sampleTaskSampleResolutionDate: year+"-01-01T00:00:00.000Z",
          fechaLlegadaReal: year+"-01-01T00:00:00.000Z",
          fechaEstimadaLlegada: year+"-01-01T00:00:00.000Z",
          fechaEnvioFabrica: year+"-01-01T00:00:00.000Z"
        })
        .then(() => {
          this.$router.push({ name: "planningSample" });
        });
    },
    discontinueSample() {
      this.$axios
        .post("api/Samples/Descatalogo", {
          idUser: this.user.id,
          idSample: this.idSample,
          sampleCancellationReason: this.cancellationReason
        })
        .then(() => {
          this.openAlert("success", "Muestra descatalogada", null);
          this.isDiscontinueModalOpen = false;
          this.cancellationReason = "";
        })
        .catch(() => this.showFriendlyError());
    },
    commentAdded(item) {
      this.sample.comen.unshift(item);
    }
  },
  watch: {
    comercialRequest() {
      this.filterPerClient(this.comercialRequest.idClient);
    }
  }
};
</script>
